<template>
  <div>
    <h3>Add Class</h3>

    <b-form @submit.prevent="submit()" class="form-horizontal">

      <b-form-group label="Find Course" label-for="course" label-class="control-label opportunity-form-label required" :class="{ 'invalid-group': $v.form.classRecordId.$error }">
      <autocomplete ref="courseAutoComplete"
                    :source="courseApi"
                    v-model="form.classRecordId"
                    placeholder="Search Courses"
                    :inputClass="{'form-control' : true, 'is-invalid': $v.form.classRecordId.$error }"
                    resultsValue="classRecordId"
                    :resultsDisplay="classDisplay"
                    credentials="include"
                    @clear="clearCourse"
                    :request-headers="requestHeaders"
                    @selected="setCourseInfo"></autocomplete>
      <span class="span-feedback invalid-feedback" v-if="$v.form.classRecordId.$error">You must select a course.</span>
    </b-form-group>

      <b-button type="submit" class="pull-right btn-primary">Save</b-button> 
    </b-form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";

export default {
  data() {
    return {
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" },
      form: {
        classRecordId: null,
        subjectCode: null,
        catalogNumber: null,
        scheduleLineNumber: null,
        unitsMinimum: null,
        unitsMaximum: null,
        locationCode: null,
        location: null,
        sessionCode: null,
        session: null,
        instructionMode: null
      }
    };
  },

  props: {
    course: {
      type: Object,
      required: false,
      default: function() {
        return {};
      }
    },
    studentOpportunityId: {
      type: Number,
      required: true
    },
    termCode: {
      type: String,
      required: true
    }
  },

  validations: {
    form: {
      classRecordId: {
        required
      }
    }
  },

  computed: {
    courseApi: function() {
      return (
        process.env.VUE_APP_BASE_URI +
        "/api/classes?termcode=" +
        this.termCode +
        "&query="
      );
    }
  },

  methods: {
    classDisplay: function(record) {
      return (
        record.subjectCode +
        " " +
        record.catalogNumber +
        " ( SLN: " +
        record.scheduleLineNumber +
        " ) - " +
        record.asurite.firstName +
        " " +
        record.asurite.lastName
      );
    },
    submit: function() {
      this.$v.$touch();

      // only submit if the form is valid
      if (!this.$v.$invalid) {
        this.save();
      }
    },

    save: function() {
      // emit refresh signal
      this.$emit("submitted", this.form);
    },
    clearCourse: function() {
      this.loadForm(this.course);
    },
    setCourseInfo: function(object) {
      this.loadForm(object.selectedObject);
    },
    loadForm(item) {
      if (item) {
        this.form = _.clone(item);
      }
    }
  },

  created() {
    if (this.course) {
      // set course info
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
